/**
 * One photo or video from a post's `photo_set`.
 *
 * `onReady` fires once there's something to show in place of a loading
 * spinner — when it has loaded, or when it has failed and shows its fallback.
 *
 * `preview` is for feed thumbnails: a video shows its first frame without
 * controls, so clicking it calls `onClick` (open the gallery) instead of playing.
 */
export default function PostMedia({ photo, className, onReady, onClick, preview }) {
  if (photo.is_video) {
    return (
      <video
        // #t=0.1 makes Safari draw the first frame instead of a blank box
        src={preview ? `${photo.image_url}#t=0.1` : photo.image_url}
        className={className}
        controls={!preview}
        muted={preview}
        playsInline
        preload="metadata"
        // with preload="metadata" loadeddata may never fire before play
        onLoadedMetadata={onReady}
        onError={onReady}
        onClick={preview ? onClick : undefined}
      />
    );
  }

  return (
    <img
      src={photo.image_url}
      alt={photo.description || "Post photo"}
      className={className}
      onLoad={onReady}
      onError={onReady}
      onClick={onClick}
    />
  );
}
